/**
 * Plan naming, in one place. Plan values arrive from several endpoints ("free", "pro",
 * "customenterprise"…) and used to be printed raw in some corners of the UI.
 */

/**
 * The one plan to show in the shell. The company's plan is what billing sets, so it wins; the page
 * prop and the cached user record are only fallbacks. Returns undefined while nothing is known yet,
 * so callers render nothing instead of a misleading "free".
 */
export function resolvePlan(
  company: { plan?: string } | null | undefined,
  planProp: string | undefined,
  user: { plan?: string } | null | undefined,
): string | undefined {
  const raw = company?.plan || planProp || user?.plan;
  return raw ? String(raw).toLowerCase() : undefined;
}

/** "customenterprise" → "Plano Enterprise", etc. Falls back to the raw value capitalized. */
export function planLabel(plan: string | undefined, t: (k: string) => string): string {
  const key = (plan || "free").toLowerCase().replace(/[^a-z]/g, "");
  const map: Record<string, string> = {
    free: "plan.free",
    pro: "plan.pro",
    professional: "plan.pro",
    enterprise: "plan.enterprise",
    customenterprise: "plan.enterprise",
    custom: "plan.enterprise",
  };
  const k = map[key];
  return k ? t(k) : `${(plan || "").charAt(0).toUpperCase()}${(plan || "").slice(1)} Plan`;
}
